function SourceOfBusiness() {
    return (
      <>
        <div className="font-bold text-lg mb-16">SourceOfBusiness</div>
      </>
    );
  }
  
  export default SourceOfBusiness;